import { commonUseCloseBtnSquared } from '../common-close-btn';
import { commonExpandBtn } from '../common-expand-btn';
import { commonArrowBtn } from '../common-use-arrow-btn';

export const commonHeaderAd = {
  ...commonUseCloseBtnSquared,
  ...commonExpandBtn,
  ...commonArrowBtn
};
